export default "__VITE_ASSET__CyMmKlSd__"